
import type { PropType } from 'vue'
import { computed, defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'DefaultImage',
  props: {
    imageUrl: String,
    alternativeText: String,
    fallbackIcon: {
      type: String,
      default: 'photograph-solid',
    },
    lazyLoading: {
      type: Boolean,
      default: true,
    },
    objectFit: {
      type: String as PropType<'cover' | 'contain'>,
      default: 'contain',
    },
    errorBackgroundColor: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const baseClass = 'default-image'

    const errorLoading = ref<boolean>(false)

    const classes = computed(() => [
      baseClass,
      {
        [`${baseClass}--error`]: errorLoading.value || !props.imageUrl,
        [`${baseClass}--error--background-color`]:
          (errorLoading.value || !props.imageUrl) && props.errorBackgroundColor,
      },
    ])

    function handleLoadingError(): void {
      errorLoading.value = true
    }

    watch(
      () => props.imageUrl,
      () => {
        errorLoading.value = false
      },
    )

    return {
      baseClass,
      classes,
      errorLoading,
      handleLoadingError,
    }
  },
})
